import { Grid, Box, Select, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { allowedLangOptions } from '../config/header';
import { usePathReconstructor } from '../config/pageRoutes';
import LangSelectorButton from './LangSelectorButton';
import { useNavigate } from 'react-router';

interface LangSelectorProps {
    size?: 'small' | 'medium';
}

const LangSelector = ({ size = "medium" }: LangSelectorProps) => {
    const { replaceParam } = usePathReconstructor();
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    function handleLanguageSelection(newLang: string) {
        i18n.changeLanguage(newLang);
        syncURL(newLang);
    };

    function syncURL(newLang: string) {
        const newURL = replaceParam("lang", newLang);
        if (newURL) navigate(newURL);
    }

    return (
        <>
            <Box className="bg-primary rounded-[65px] w-max flex items-center">
                <Select
                    value={i18n.language}
                    onChange={(e) => handleLanguageSelection(e.target.value)}
                    variant='outlined'
                    sx={{
                        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                        '.MuiSelect-select': { padding: '2px 6px' },
                        backgroundColor: 'transparent',
                        '& .MuiSelect-icon': {
                            color: 'white',
                        },
                    }}
                >
                    {allowedLangOptions.map((lang) => (
                        <MenuItem key={lang.iso} value={lang.value} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LangSelectorButton
                                onClick={() => { handleLanguageSelection(lang.value) }}
                                imgUrl={process.env.REACT_APP_PUBLIC_URL + '/assets/flags/' + lang.iso.toLowerCase() + '.png'}
                                title={lang.label}
                                size={size}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </>)
}

export default LangSelector